/**
 * My Account page entry — split into component files:
 * - workspace/js/myaccount/replace-attachment.js
 * - workspace/js/myaccount/edit-fab.js
 *
 * The page guard lives in each component file so unrelated pages
 * are never touched.
 */
